import { Component, OnInit } from '@angular/core';
import { SharedService } from '../../services/shared.service';
import { StatePersistService } from 'src/app/core/services/state-persist.service';
import { Router } from '@angular/router';

@Component({
    selector: 'footer',
    templateUrl: './footer.component.html',
    styleUrls: ['./footer.component.scss'],
    standalone: false
})
export class FooterComponent implements OnInit {
  current_date = new Date().getFullYear()
  categories = [];
  location = '';
  constructor(private sharedService: SharedService,
    private statePersist: StatePersistService,
    private router: Router) { }

  ngOnInit(): void {
    this.getCatgoryListing()
    this.getCmspage()
  }

  changeCategory(obj){
    if (obj == 'All'){
      let data;
      data = this.statePersist.getLocalStorage('product_data')
      if(data !== null){
        data['cat_id'] = ''
        if(this.router.url === '/product/listing/All'){
          if(data.search_keyword !== ''){
            data['search_keyword'] = ''
            this.statePersist.setLocalStorage('product_data', data, 'search')
            this.statePersist.setLocalStorage('product_data', data, 'product-data-update')
          }
        }
        else{
          data['search_keyword'] = ''
          this.statePersist.setLocalStorage('product_data', data, 'search')
        }
        this.statePersist.setLocalStorage('selected_category', '')
        this.router.navigate(['/product/listing/All'])
      }
      else{
        this.router.navigate(['/product/listing/All'])
      }
    }
    else{
      let data;
      data = this.statePersist.getLocalStorage('product_data')
      if(data !== null){
        data['cat_id'] = obj.id
        if(this.router.url == '/product/listing/' + obj.id + '-' + obj.url_key){
          if(data.search_keyword !== ''){
            data['search_keyword'] = ''
            this.statePersist.setLocalStorage('product_data', data, 'search')
            this.statePersist.setLocalStorage('product_data', data, 'product-data-update')
          }

        }
        else{
          data['search_keyword'] = ''
          this.statePersist.setLocalStorage('product_data', data, 'search')
        }
        this.statePersist.setLocalStorage('selected_category', obj.id)
        this.router.navigate(['/product/listing/' + obj.id + '-' + obj.url_key])
      }
      else{
        this.statePersist.setLocalStorage('product_data', {'brand_filter':''}); 
        this.router.navigate(['/product/listing/' + obj.id + '-' + obj.url_key])
      }
    }
  }

  getCatgoryListing() {
    this.sharedService.getCategories()
    .subscribe(
      data => {
        if (data.response) {
          this.categories = data.response.footer_categories
        }
      }
    );
  }

  getCmspage() {
    this.sharedService.getCmspage()
    .subscribe(
      data => {
        if (data.response) {
          this.location = data.response.address_details
        }
      }
    );
  }

}
